import isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: ({ viewAnimation, initStyles }) => {
        const style = {
            display: 'flex',
            height: '100%',
            width: '100%',

            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            overflow: 'scroll',
        };

        if (viewAnimation) {
            styles.opacity = 0;
        }
            
        if (!isEmpty(initStyles)) {
            styles.transform = initStyles.transform;
            styles.opacity = initStyles.opacity;
        }

        return  style;
    },
});

export default styles;
export const useStyles = makeStyles(styles);
